'use strict';
(function () {
  var jsSelectorForm = '[data-js="js-ems-form"]';
  var jsSelectorDynamicContainer = '[data-js="js-dynamic-container"]';
  var jsSelectorDynamicBtn = '[data-js="js-dynamic-btn"]';
  var jsSelectorTotalInput = '[data-js="js-total"]';
  var jsSelectorDonationInput = '[data-js="js-donation"]';
  var jsSelectorRadioLineItems = '[data-js="js-line-item"]';

  var elForm = document.querySelector(jsSelectorForm);

  function initAddBtn(masterContainer) {
    function initClonedRemoveBtn(clonedContainer) {
      var clonedBtn = clonedContainer.querySelector(jsSelectorDynamicBtn);
      if (!clonedBtn) {return;}

      function handlerRemoveInputContainer(e) {
        masterContainer.parentElement.removeChild(clonedContainer);
        masterContainer.checkLimitByCount();
      }

      clonedBtn.addEventListener('click', handlerRemoveInputContainer);
      clonedBtn.setAttribute('aria-label', 'remove household member');
      clonedBtn.classList.add('o-fieldset__input-btn--minus');
      clonedBtn.innerHTML = '';
    }

    function initClonedInput(clonedContainer, count) {
      var clonedInput = clonedContainer.querySelector('input');
      if (!clonedInput) {return;}

      var nameId = clonedInput.id + count;
      clonedInput.setAttribute('id', nameId);
      clonedInput.value = '';
    }

    function initLimitAddtionalByCount(addBtn) {
      var limit = 10;
      return function limitAdditionalByCount() {
        var count = this.parentElement.childElementCount;
        if (count > limit) {
          addBtn.classList.add('u-display--none');
        } else {
          addBtn.classList.remove('u-display--none');
        }
      };
    }

    function handlerAddNewInputContainer(e) {
      var clonedContainer = masterContainer.cloneNode(true);
      initClonedRemoveBtn(clonedContainer);
      initClonedInput(clonedContainer, ++masterContainer.dynamicCount);
      masterContainer.parentElement.appendChild(clonedContainer);
      masterContainer.checkLimitByCount();
    }

    masterContainer.dynamicCount = 0;
    var elContainerBtn = masterContainer.querySelector(jsSelectorDynamicBtn);
    if (!elContainerBtn) {return;}
    masterContainer.checkLimitByCount = initLimitAddtionalByCount(elContainerBtn);
    elContainerBtn.addEventListener('click', handlerAddNewInputContainer);
  }

  function initDynamicContentListeners() {
    var dynamicContainers = elForm.querySelectorAll(jsSelectorDynamicContainer);
    for (var i = 0; i < dynamicContainers.length; i++) {
      initAddBtn(dynamicContainers[i]);
    }
  }
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  initDynamicContentListeners();
  //----------------------------------------------------------------------
  //______________________________________________________________________
  function initTotalCalculator() {
    var elTotal = elForm.querySelector(jsSelectorTotalInput);
    var elDonation = elForm.querySelector(jsSelectorDonationInput);
    var nodesInputLineItems = elForm.querySelectorAll(jsSelectorRadioLineItems);

    if (!elTotal || !elDonation || nodesInputLineItems < 1) return;

    var getRadioVal = function getRadioVal() {return 0;};

    function getDonationVal() {
      return parseFloat(elDonation.value) || 0;
    }

    function setRadioVal(element) {
      return function () {
        return parseFloat(element.getAttribute('data-value'));
      };
    }

    function setRadioLineItemVal(lineItem) {
      getRadioVal = setRadioVal(lineItem);
    }

    function calculateTotal() {
      var calcTotal = (getRadioVal() + getDonationVal()).toFixed(2);
      elTotal.value = isNaN(calcTotal) ? 'error' : calcTotal;
    }

    function handlerRadioValClick(e) {
      setRadioLineItemVal(e.target);
      calculateTotal();
    }

    function handlerDonationChange(e) {
      calculateTotal();
    }

    function initRadioLineItem(radioLineItem) {
      radioLineItem.addEventListener('click', handlerRadioValClick);
      if (radioLineItem.checked === true) {
        setRadioLineItemVal(radioLineItem);
        calculateTotal();
      }
    }

    for (var i = 0; i < nodesInputLineItems.length; i++) {
      initRadioLineItem(nodesInputLineItems[i]);
    }

    elDonation.addEventListener('input', handlerDonationChange);
  }
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  initTotalCalculator();
  //----------------------------------------------------------------------
  //______________________________________________________________________

  function convertFormToObj(form) {
    var obj = {};

    function _addOrAppend(field, value) {
      obj[field.name] = !obj[field.name] ? value : obj[field.name] + ', ' + value;
    }

    function _loopMultiSelect(field) {
      for (var n = 0; n < field.options.length; n++) {
        field.options[n].selected && _addOrAppend(field, field.options[n].value);
      }
    }

    function _isValidField(field) {
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
        return false;
      }
      return true;
    }

    for (var i = 0; i < form.elements.length; i++) {
      var field = form.elements[i];
      if (_isValidField(field)) {
        if (field.type === 'select-multiple') {
          _loopMultiSelect(field);
        } else if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
          field.value.length && _addOrAppend(field, field.value);
        }
      } else {
        //console.log(field, 'notValid')
      }
    }
    return obj;
  }

  function initConvertFormToObj(curForm) {
    return function _convertFormToObj() {
      return convertFormToObj(curForm);
    };
  }

  function initSecondaryAction(curForm) {
    return function _secondaryAction(responseText) {
      var responseJson = JSON.parse(responseText);
      if (responseJson.Items) {
        var stringJson = JSON.stringify(responseJson.Items);
        curForm.Items.value = stringJson;
        curForm.submit();
      }
    };
  }

  function initXhrCustomSubmit(setWaiting) {
    // look up dynamic url value
    var url = window.location.origin + elForm.getAttribute('data-url');
    var xhr = new XMLHttpRequest();

    function _onReadyStateChange(secondaryAction) {
      return function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            secondaryAction(xhr.responseText);
          } else {
            console.error('An error occurred during your request!\n              status: ' +
            xhr.status + '\n              status text: ' +
            xhr.statusText);
          }
          setWaiting(false);
        }
      };
    }

    return function _customSubmit(data, secondaryAction) {
      setWaiting(true);
      xhr.open('POST', url);
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
      xhr.onreadystatechange = _onReadyStateChange(secondaryAction);
      var stringJsonData = JSON.stringify(data);
      xhr.send(stringJsonData);
    };
  }

  var formController = {
    waiting: false,
    formObj: initConvertFormToObj(elForm),
    secondaryAction: initSecondaryAction(elForm) };


  function setWaiting(bool) {
    formController.waiting = bool;
  }

  formController.submit = initXhrCustomSubmit(setWaiting);

  function handlerFormSubmit(e) {
    if (formController.waiting) return;
    e.preventDefault();
    formController.submit(formController.formObj(), formController.secondaryAction);
  }

  elForm.addEventListener('submit', handlerFormSubmit);
})();